import { cn } from "@/lib/utils";

/**
 * Pins a listing filter rail under the fixed nav on desktop, matching the
 * customer-story sidebar pattern (`sticky` + `self-start` inside a column that
 * stretches with the posts list). The rail scrolls out of view once the listing
 * section leaves the viewport.
 */
export function BlogFilterStickyAside({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "bg-grey-0 sticky top-[calc(var(--nav-offset)+16px)] self-start",
        className
      )}
    >
      {children}
    </div>
  );
}
